import { Switch as SwitchComponent, SwitchProps, useMediaQuery, useTheme } from '@mui/material';
import { Controller, Control } from 'react-hook-form';

interface Props extends Omit<SwitchProps, 'name'> {
  name: string;
  control: Control<any>;
  onToggle?: (checked: boolean) => void;
}

export default function Switch({ name, control, onToggle, ...switchProps }: Props) {
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));
  const size = switchProps.size || (isLargeScreen ? 'medium' : 'small');

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={false}
      render={({ field }) => (
        <SwitchComponent
          {...field}
          checked={!!field.value}
          size={size}
          onChange={(event) => {
            const isChecked = event.target.checked;
            field.onChange(isChecked);
            if (onToggle) {
              onToggle(isChecked);
            }
          }}
          {...switchProps}
        />
      )}
    />
  );
}
